import './slider/slider';